import { render, staticRenderFns } from "./email-bulk-message-list-item.vue?vue&type=template&id=09ae4fdc"
import script from "./email-bulk-message-list-item.vue?vue&type=script&lang=js"
export * from "./email-bulk-message-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09ae4fdc')) {
      api.createRecord('09ae4fdc', component.options)
    } else {
      api.reload('09ae4fdc', component.options)
    }
    module.hot.accept("./email-bulk-message-list-item.vue?vue&type=template&id=09ae4fdc", function () {
      api.rerender('09ae4fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/send-list/list/common-bulk-message-list/email-bulk-message-list-item.vue"
export default component.exports